import { render, staticRenderFns } from "./ExpertizeList.vue?vue&type=template&id=2fbda812&scoped=true&"
import script from "./ExpertizeList.vue?vue&type=script&lang=js&"
export * from "./ExpertizeList.vue?vue&type=script&lang=js&"
import style0 from "./ExpertizeList.vue?vue&type=style&index=0&id=2fbda812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbda812",
  null
  
)

export default component.exports